import { TicketDepartmentType, userType } from "../../DTO";
import { Api } from "../api";

export const ListTicketDepartments = (user: userType) => {
    return new Promise<{ departments: TicketDepartmentType[] }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: "tickets/departments",
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
            });

            return api
                .call()
                .then((data: any) =>
                    resolve({ departments: data.data }),
                )
                .catch((err: any) => reject(err?.data?.message ?? err));
        },
    );
};
